<template>
    <div class="row">
        <div class="col-12 text-navy">
            <div v-for="(basket_product, key) in basketProducts" :key="key" class="basket-product">
                <div class="badge bg-light text-black mb-1" v-if="basket_product.tyre_position != null && basket_product.tyre_position != '' && basket_product.tyre_position != 'same'">
                    <small class="text-capitalize fw-bold">{{ basket_product.tyre_position }} tyres</small>
                </div>
                <div v-else-if="basket_product.tyre_position != null && (basket_product.tyre_position == 'same' || basket_product.tyre_position == '')" class="badge bg-light text-black mb-1">
                    <small class="text-capitalize fw-bold">front/rear tyre{{ basket_product.quantity != 1 ? 's' : '' }}</small>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                    <b>{{ basket_product.brand }}</b>
                    <p class="mb-0 text-18">£{{ basket_product.retail }}</p>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex flex-column">
                        <p class="mb-0">{{ basket_product.tyre_range }}</p>
                        <small class="fw-light">{{ basket_product.size }} {{ basket_product.load_speed }}</small>
                    </div>
                    <div class="d-flex align-items-center">
                        <update-quantity :tyre="basket_product"></update-quantity>
                    </div>
                </div>
                <hr class="my-2">
            </div>
            <div v-for="(basket_product, key) in basketServices" :key="key" class="basket-product">
                <small v-if="key == 0">Selected extras</small>
                <div class="d-flex justify-content-between align-items-center py-2">
                    <span class="flex-fill fw-bold">{{ basket_product.service_name }}</span>
                    <span class="text-18">
                        &pound;{{ parseFloat(basket_product.retail * basket_product.quantity).toFixed(2) }}
                    </span>
                </div>
                <hr class="my-2">
            </div>
            <div class="d-flex justify-content-between align-items-center py-1">
                <b>Sub total:</b>
                <span class="text-18">&pound;{{ basket.sub_total }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center py-1" v-if="basket.home_delivery == true && basket.delivery_amount > 0">
                <span>Delivery charge:</span>
                <span>&pound;{{ basket.delivery_amount }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center py-1" v-if="basket.mobile_fitting > 0">
                <span>Mobile fitting:</span>
                <span>&pound;{{ basket.mobile_fitting }}</span>
            </div>
            <div class="py-1" v-if="basket.disposal_fee > 0">
                <div class="d-flex align-items-center justify-content-between">
                    <b>Environmental Fee:</b>
                    <span>&pound;{{ basket.disposal_fee }}</span>
                </div>
                <disposal-fee-info></disposal-fee-info>
            </div>
            <discounts :basket="basket"></discounts>
            <hr class="my-2">
            <div class="d-flex justify-content-between align-items-center py-2">
                <b class="text-navy text-18">Total:</b>
                <b class="text-18">&pound;{{ basket.total }}</b>
            </div>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import basket from '@shared/mixins/basket';

    export default {
        props: ['basket', 'services'],
        mixins: [basket],
        components: { Field, ErrorMessage },
        computed: {
            basketProducts() {
                if(this.basket.products) {
                    let query = this.basket.products.filter((basket_product) => {
                        return (basket_product.product_type == 'product');
                    });

                    return query;
                }
            },
            basketServices() {
                if(this.basket.products) {
                    let query = this.basket.products.filter((basket_product) => {
                        return (basket_product.product_type == 'service');
                    });

                    return query;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form-select {
        background-position-x: 87%;
    }
</style>